import {
  MotorFunnelState,
  MotorStepType,
  MotorFlowType,
  PolicyHolder,
  MotorFlowDefinition,
  MotorFormAnswer,
} from 'scenes/motor/types';

interface HasIndex {
  index: number;
}

const insertPolicyHolder = (
  array: PolicyHolder[],
  item: Partial<PolicyHolder> & HasIndex
) => {
  const copy = [...array];
  copy[item.index] = { ...(item as PolicyHolder), isSelected: true };
  return copy;
};

const addPolicyHolder = (
  funnelState: MotorFunnelState
): Partial<MotorFunnelState> => ({
  step: MotorStepType.AddPolicyHolder,
  flow: MotorFlowType.PolicyDetails,
  [MotorFlowType.PolicyDetails]: {
    ...funnelState.policyDetails,
    policyHolders: insertPolicyHolder(
      funnelState.policyDetails.policyHolders,
      funnelState.addPolicyHolder
    ),
  },
});

export const forwardLinks: MotorFlowDefinition = {
  [MotorStepType.Name]: (
    funnelState: MotorFunnelState,
    answer: MotorFormAnswer
  ) => ({
    step: MotorStepType.GenderAndDateOfBirth,
    [MotorFlowType.AddPolicyHolder]: {
      ...funnelState.addPolicyHolder,
      firstName: answer.formValues.firstName,
      lastName: answer.formValues.lastName,
    },
  }),
  [MotorStepType.GenderAndDateOfBirth]: (funnelState: MotorFunnelState) =>
    addPolicyHolder(funnelState),
};

export const backwardLinks: MotorFlowDefinition = {
  [MotorStepType.Name]: {
    step: MotorStepType.AddPolicyHolder,
    flow: MotorFlowType.PolicyDetails,
  },
  [MotorStepType.GenderAndDateOfBirth]: { step: MotorStepType.Name },
};
